// NS3600:2018 veiledning for ulike romtyper

export const NS3600Veiledning = {
  bad: {
    tittel: 'Befaring av bad etter NS3600:2018',
    undersokelser: [
      {
        kategori: 'Obligatorisk undersøkelse (§2-18)',
        punkter: [
          'Hulltaking i tilstøtende vegger for å avdekke fuktskader',
          'Visuell kontroll av membran ved sluk (der tilgjengelig)',
          'Måling av høydeforskjell slukrist til gulv/membran (min 25 mm)',
          'Kontroll av fall mot sluk',
        ],
      },
      {
        kategori: 'Visuelle kontroller',
        punkter: [
          'Overflater: vegg, himling, gulv (fuktskader, mugg, sopp)',
          'Fuger og overganger (sprekkdannelser)',
          'Sluk og membran (synlige deler)',
          'Ventilasjon (type, funksjon)',
          'Sanitærutstyr (lekkasjer, rust, skader)',
        ],
      },
    ],
    tilstandsgrader: {
      TG0: {
        beskrivelse: 'Som ny',
        kriterier: [
          'Membran dokumentert lagt etter forskriftene',
          'Ingen synlige skader eller slitasje',
          'Hulltaking viser ingen fukt',
          'Korrekt fall og høydeforskjell',
        ],
      },
      TG1: {
        beskrivelse: 'Meget god',
        kriterier: [
          'Membran sannsynligvis korrekt utført',
          'Ubetydelig slitasje på overflater',
          'Hulltaking viser ingen/liten fukt',
          'Ventilasjon fungerer tilfredsstillende',
        ],
      },
      TG2: {
        beskrivelse: 'God - vedlikeholdsetterslep',
        kriterier: [
          'Middels slitasje på overflater',
          'Fuger med sprekkdannelser',
          'Membran ukjent eller manglende dokumentasjon',
          'Ventilasjon redusert funksjon',
          'Vedlikehold nødvendig innen 2-5 år',
        ],
      },
      TG3: {
        beskrivelse: 'Dårlig - tiltak nødvendig',
        kriterier: [
          'Membran defekt eller mangler',
          'Fuktskader påvist i hulltaking',
          'Omfattende sopp/mugg',
          'Manglende/ikke-fungerende ventilasjon',
          'Utbedring nødvendig umiddelbart',
        ],
      },
    },
    referanser: [
      'NS3600:2018 Tabell A.1 - Våtrom',
      'Forskrift om tryggere bolighandel §2-18',
      'TEK17 §13-9 Beskyttelse mot fukt',
    ],
  },

  kjokken: {
    tittel: 'Befaring av kjøkken etter NS3600:2018',
    undersokelser: [
      {
        kategori: 'Visuelle kontroller',
        punkter: [
          'Benkeplate (slitasje, fuktskader)',
          'Skap og skuffer (slitasje, hengsler)',
          'Hvitevarer (alder, funksjon)',
          'Ventilasjon/avtrekk (type, funksjon)',
          'Gulv (slitasje, fuktskader)',
          'Vegg bak benk og komfyr (fuktskader)',
        ],
      },
      {
        kategori: 'Funksjonskontroll',
        punkter: [
          'Vannkran og blandebatteri',
          'Sluk (hvis vaskemaskin)',
          'Avtrekksvifte (lydnivå, effekt)',
          'Komfyr/koketopp',
        ],
      },
    ],
    tilstandsgrader: {
      TG0: {
        beskrivelse: 'Som nytt',
        kriterier: [
          'Nytt kjøkken eller totalrenovert',
          'Ingen synlig slitasje',
          'Alt utstyr fungerer perfekt',
        ],
      },
      TG1: {
        beskrivelse: 'Meget god',
        kriterier: [
          'Ubetydelig slitasje',
          'Benkeplate og innredning i god stand',
          'Ventilasjon fungerer',
        ],
      },
      TG2: {
        beskrivelse: 'God - vedlikeholdsetterslep',
        kriterier: [
          'Synlig slitasje på benkeplate',
          'Hengsler/beslag trenger justering',
          'Avtrekk redusert funksjon',
          'Vedlikehold/oppgradering nødvendig innen 2-5 år',
        ],
      },
      TG3: {
        beskrivelse: 'Dårlig - utskifting nødvendig',
        kriterier: [
          'Omfattende slitasje eller skader',
          'Fuktskader i skap/benkeplate',
          'Manglende/ikke-fungerende ventilasjon',
          'Hvitevarer defekte',
        ],
      },
    },
    referanser: [
      'NS3600:2018 Tabell A.1 - Kjøkken',
      'TEK17 §13-8 Ventilasjon',
    ],
  },

  soverom: {
    tittel: 'Befaring av soverom etter NS3600:2018',
    undersokelser: [
      {
        kategori: 'Visuelle kontroller',
        punkter: [
          'Overflater (vegg, himling, gulv)',
          'Vinduer (funksjon, tetting)',
          'Dører (funksjon, tetting)',
          'Gulvbelegg (slitasje, skader)',
        ],
      },
      {
        kategori: 'Kontroll etter TEK17',
        punkter: [
          'Rømningsvei (vindu eller dør til sikker sone)',
          'Dagslysflate minst 1/10 av gulvflate',
          'Ventilasjon',
          'Elektriske installasjoner',
        ],
      },
    ],
    tilstandsgrader: {
      TG0: {
        beskrivelse: 'Som nytt',
        kriterier: [
          'Nyoppusset eller nybygget',
          'Ingen synlig slitasje',
          'Alle krav til rømningsvei og dagslys oppfylt',
        ],
      },
      TG1: {
        beskrivelse: 'Meget god',
        kriterier: [
          'Ubetydelig slitasje',
          'Overflater i god stand',
          'TEK-krav oppfylt',
        ],
      },
      TG2: {
        beskrivelse: 'God - vedlikeholdsetterslep',
        kriterier: [
          'Slitasje på gulv/overflater',
          'Vinduer/dører trenger vedlikehold',
          'Maling/tapet nedslitt',
        ],
      },
      TG3: {
        beskrivelse: 'Dårlig - tiltak nødvendig',
        kriterier: [
          'Fuktskader i overflater',
          'Manglende rømningsvei (TEK-brudd)',
          'Utilstrekkelig dagslys',
          'Omfattende vedlikehold nødvendig',
        ],
      },
    },
    referanser: [
      'NS3600:2018 Tabell A.1 - Soverom',
      'TEK17 §11-7 Rømningsvei',
      'TEK17 §13-2 Dagslys',
    ],
  },

  vaskerom: {
    tittel: 'Befaring av vaskerom etter NS3600:2018',
    undersokelser: [
      {
        kategori: 'Obligatorisk undersøkelse (§2-18)',
        punkter: [
          'Hulltaking hvis våtrom med membran',
          'Visuell kontroll av sluk og membran',
        ],
      },
      {
        kategori: 'Visuelle kontroller',
        punkter: [
          'Gulv (fuktbestandig materiale, fall mot sluk)',
          'Vegger (fuktskader)',
          'Ventilasjon (type, funksjon)',
          'Vannkran og sluk',
        ],
      },
    ],
    tilstandsgrader: {
      TG1: 'Ubetydelig slitasje, ingen fuktskader',
      TG2: 'Middels slitasje, vedlikehold nødvendig',
      TG3: 'Fuktskader, membran defekt',
    },
    referanser: ['NS3600:2018 Tabell A.1 - Vaskerom'],
  },
};

export const hentVeiledning = (romtype) => {
  return NS3600Veiledning[romtype] || null;
};
